import React from 'react';
import { Stack } from '@mui/material';
import { TypographyStepTitle, TypographyInstruction } from '../style/typography';

const UploadCsvfileSteps = ({ stepNumber, title, description, children, ...props }) => {
  return (
    <div {...props}>
      <TypographyStepTitle>
        STEP{stepNumber}　{title}
      </TypographyStepTitle>
      <Stack spacing={{ xs: 1, sm: 2, md: 2 }} m={{ xs: 1, sm: 2, md: 2 }}>
        <TypographyInstruction>
          {description}
        </TypographyInstruction>
        {children}
      </Stack>
    </div>
  );
};

export default UploadCsvfileSteps;